module.exports = __webpack_public_path__ + "314210a4825a7cc8ca7db893dfd9d283.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-LightItalic.woff2
// module id = 980
// module chunks = 0